import Spacer from '.';

/** @type {UICore.ComponentMeta} */
const SpacerComponentMeta = {
  id: 'w-spacer',
  name: '留白',
  icon: 'https://vfiles.gtimg.cn/wuji_dashboard/xy/rainbow/icon-spacer_1636365212836.png',
  category: '布局',
  component: Spacer,
  propsSchema: {
    type: 'object',
    fields: []
  }
};
export default SpacerComponentMeta;